import { townColorHex as hex, type TownPropPalette } from './townPropTemplates';

/** Side-growing bracket shelves. The opaque left mycelium patch binds to the
 * host; three scalloped caps project into open air, with quiet colored rims. */
export function buildShelfFungusBody(p: TownPropPalette): string {
  return `<g data-part="shelf-fungus">
    <path d="M3 12H9V30H3Z" fill="${hex(p.wood)}" />
    <path d="M6 13L13 10L17 14L12 22L15 29L9 33L4 28Z" fill="${hex(p.wood)}" />
    <path d="M6 15L9 18L6 23L9 28" fill="none" stroke="${hex(p.woodEdge)}" stroke-width="1.2" />
    <path d="M8 13Q17 3 32 5Q39 5 43 10L40 15Q23 20 8 17Z" fill="${hex(p.primary)}" />
    <path d="M8 15Q22 11 41 12L40 15Q23 20 8 17Z" fill="${hex(p.shade)}" />
    <path d="M11 12Q22 6 34 8M11 14Q26 10 38 11" fill="none" stroke="${hex(p.roofEdge)}" stroke-width="1.2" opacity=".6" />
    <path d="M10 16Q24 19 40 14" fill="none" stroke="${hex(p.glass)}" stroke-width="1.5" />
    <path d="M9 23Q19 15 36 16Q51 14 60 23L57 29Q32 36 9 28Z" fill="${hex(p.primary)}" />
    <path d="M9 26Q35 20 59 24L57 29Q32 36 9 28Z" fill="${hex(p.shade)}" />
    <path d="M14 23Q34 15 51 22 M13 25Q36 19 55 24" fill="none" stroke="${hex(p.roofEdge)}" stroke-width="1.3" opacity=".65" />
    <path d="M11 28Q31 33 57 28" fill="none" stroke="${hex(p.glass)}" stroke-width="1.8" />
    <path d="M16 28L21 30 M28 27L31 31 M43 27L42 31 M51 27L49 30"
      stroke="${hex(p.glassCore)}" stroke-width=".8" opacity=".6" />
    <path d="M8 33Q17 27 31 31L39 36L35 40Q20 43 8 37Z" fill="${hex(p.primary)}" />
    <path d="M8 36Q23 32 38 36L35 40Q20 43 8 37Z" fill="${hex(p.shade)}" />
    <path d="M12 34Q23 30 32 34" fill="none" stroke="${hex(p.roofEdge)}" stroke-width="1.2" opacity=".65" />
    <path d="M10 38Q23 42 35 38" fill="none" stroke="${hex(p.glass)}" stroke-width="1.4" />
  </g>`;
}
